import { Menu } from "@headlessui/react";
import { useAuth } from "../hooks/useAuth";
import { classNames } from "../utils/functions";

export default function LogoutButton() {
  const { logout } = useAuth();
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={logout}
          className={classNames(
            active
              ? "bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-700 text-gray-900 dark:text-white"
              : "text-gray-700 dark:text-gray-300",
            "group relative flex items-center w-full px-6 py-3 text-sm font-light tracking-wider uppercase transition-all duration-300 hover:bg-gradient-to-r hover:from-red-500/5 hover:via-pink-500/5 hover:to-red-500/5"
          )}
        >
          {/* Decorative gradient line */}
          <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 group-hover:h-6 bg-gradient-to-b from-red-500 via-pink-500 to-red-600 rounded-full transition-all duration-300" />

          <span className="relative z-10 ml-2">Sign Out</span>

          {/* Arrow indicator */}
          <div className="ml-auto w-3 h-3 text-gray-400 dark:text-gray-500 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
          </div>
        </button>
      )}
    </Menu.Item>
  );
}
